import {
    FETCH_NEXT,
    FETCH_INIT,
    FETCHED,
    FILTER,
    RESET_FILTER,
    SET_SORTING,
    SET_FILTER,
    SET_PAGE,
    CHANGE_PAGE,
    CHANGE_STATUS,
    SET_SERVER_PAGE,
    CREATE_DATA,
    UPDATE_DATA,
    DELETE_ITEM,
    SET_CLIENT_ID,
    SET_PROGRAM_ID
} from '../actions/AppUsers.action';

import Constants from '../config/constants';

function mapPresetPRequest(all, pageId) {
    return all.filter((val, index) => {
        if (
            index >= (((pageId + 1) * Constants.DEFAULT_PAGE_VALUE) - Constants.DEFAULT_PAGE_VALUE) &&
            index < (((pageId + 1) * Constants.DEFAULT_PAGE_VALUE))
        ) {
            return val;
        }
    });
}

const initialState = {
    all: [],
    present: [],
    currentPage: 0,
    serverPage: 0,
    query: null,
    query_data: null,
    sorting_data: { row: null, order: null },
    is_fetching: false,
    client_id: "",
    program_id: ""
};

export default function (state = JSON.parse(JSON.stringify(initialState)), action) {
    switch (action.type) {

        case FETCH_INIT:
            return { ...state, is_fetching: true };

        case FETCHED: {
            const newData = action.payload.data;
            const page = action.payload.page;

            let newAll = [];
            if (page == 1) {
                newAll = [...newData];
            } else {
                newAll = [...state.all, ...newData];
            }

            const tableData = mapPresetPRequest(newAll, state.currentPage);
            return { ...state, all: newAll, present: tableData, is_fetching: false };
        }

        case SET_CLIENT_ID:
            return { ...state, client_id: action.payload };

        case SET_PROGRAM_ID:
            return { ...state, program_id: action.payload };

        case SET_SORTING:
            return { ...state, sorting_data: action.payload };

        case CHANGE_STATUS: {
            if (!action.payload) return state;

            const newAll = state.all.filter(val => val.id !== action.payload.id);
            const tableData = mapPresetPRequest(newAll, state.currentPage);

            return { ...state, all: newAll, present: tableData };
        }

        case CREATE_DATA: {
            if (!action.payload) return state;

            const newAll = [action.payload, ...state.all];
            const tableData = mapPresetPRequest(newAll, state.currentPage);

            return { ...state, all: newAll, present: tableData };
        }

        case UPDATE_DATA: {
            if (!action.payload) return state;

            const newAll = state.all.map(val =>
                val.id === action.payload.id ? action.payload : val
            );

            const tableData = mapPresetPRequest(newAll, state.currentPage);
            return { ...state, all: newAll, present: tableData };
        }

        case DELETE_ITEM: {
            if (!action.payload) return state;

            const newAll = state.all.filter(val => val.id !== action.payload);
            const tableData = mapPresetPRequest(newAll, state.currentPage);

            return { ...state, all: newAll, present: tableData };
        }

        case CHANGE_PAGE: {
            const tempPage = action.payload;
            const tableData = mapPresetPRequest(state.all, tempPage);
            return { ...state, present: tableData, currentPage: tempPage };
        }

        case FETCH_NEXT: {
            const newAll = state.all.concat(action.payload);
            return { ...state, all: newAll, serverPage: state.serverPage + 1 };
        }

        case FILTER:
            return { ...state, present: action.payload };

        case SET_FILTER:
            return {
                ...state,
                query: action.payload.query,
                query_data: action.payload.query_data
            };

        case RESET_FILTER: {
            const tableData = mapPresetPRequest(state.all, state.currentPage);
            return { ...state, present: tableData };
        }

        case SET_PAGE:
            return { ...state, currentPage: action.payload };

        case SET_SERVER_PAGE:
            return { ...state, serverPage: action.payload };

        default:
            return state;
    }
}